<script setup lang="ts">
  import { useThemeConfig } from '@core/composable/useThemeConfig';
  import type { ThemeSwitcherTheme } from '@layouts/types';

  const props = defineProps<{
    themes: ThemeSwitcherTheme[];
  }>();

  const { theme } = useThemeConfig();

  const {
    state: currentThemeName,
    next: getNextThemeName,
    index: currentThemeIndex
  } = useCycleList(
    props.themes.map(t => t.name),
    { initialValue: theme.value }
  );

  const changeTheme = () => {
    theme.value = getNextThemeName();
  };

  // Update icon if theme is changed from other sources
  watch(theme, val => {
    currentThemeName.value = val;
  });
</script>

<template>
  <IconBtn @click="changeTheme">
    <Transition name="theme-icon" mode="out-in">
      <VIcon :key="props.themes[currentThemeIndex].icon" size="26" :icon="props.themes[currentThemeIndex].icon" />
    </Transition>
    <VTooltip activator="parent" open-delay="1000" scroll-strategy="close">
      <span class="text-capitalize">{{ currentThemeName }}</span>
    </VTooltip>
  </IconBtn>
</template>

<style scoped>
  .theme-icon-enter-active,
  .theme-icon-leave-active {
    transition:
      transform 0.25s ease,
      opacity 0.25s ease;
  }

  .theme-icon-enter-from {
    opacity: 0;
    transform: rotate(-90deg) scale(0.6);
  }

  .theme-icon-leave-to {
    opacity: 0;
    transform: rotate(90deg) scale(0.6);
  }
</style>
